import React from 'react';
import './index.css';
import { Container, Row, Col } from 'react-bootstrap';
import parse from 'html-react-parser';

const WhyChooseLoanProgram = ({ data }) => {
  // If data is undefined or null, return null to avoid rendering
  if (!data) return null;
  
  // Destructure data to get title, subtitle, and items
  const { title, subtitle, items, footerText, colsize=4 } = data;
  
  const renderCard = (item, index) => {
    const cardContent = (
      <>
        {item.icon && (
          <div className="why-choose-icon">
            <img src={`${process.env.REACT_APP_LOANPROGRAMS_URL || ''}common/${item.icon}`} alt={item.title} />
          </div>
        )}
        {item.title && <h3 className="why-choose-item-title">{parse(item.title)}</h3>}
        {item.description && <p className="why-choose-item-text">{parse(item.description)}</p>}
      </>
    );

    return (
      <Col md={6} lg={colsize} key={index} className="why-choose-item-col g-3">
        {item.link ? (
          <a href={item.link} className="why-choose-item-link" target="_blank" rel="noopener noreferrer">
            <div className="why-choose-item has-link">
              {cardContent}
            </div>
          </a>
        ) : (
          <div className="why-choose-item">
            {cardContent}
          </div>
        )}
      </Col>
    );
  };
  
  return (
    <section className="why-choose-section">
      <Container>
        <div className="text-center">
          {title && <h2 className="why-choose-title">{parse(title)}</h2>}
          {subtitle && <p className="why-choose-subtitle">{parse(subtitle)}</p>}
        </div>
        <Row className="why-choose-items">
          {items && items.map((item, index) => renderCard(item, index))}
        </Row>
        {footerText && (
          <div className="why-choose-footer text-center mt-3">
            <p>{parse(footerText)}</p>
          </div>
        )}
      </Container>
    </section>
  );
};

export default WhyChooseLoanProgram;